// Commercial — Entonnoir de conversion global (bars horizontales).
import { Loader2 } from "lucide-react";
import { useCommercialFetch, FUNNEL_COLORS } from "./useCommercialFetch";

export default function CommercialFunnelGlobalWidget() {
  const { data, loading, error } = useCommercialFetch();

  if (loading) {
    return (
      <div className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error || !data) {
    return (
      <div className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}>
        Erreur Funnel : {error || "—"}
      </div>
    );
  }

  const funnel = data.funnel || [];
  const maxCount = funnel[0]?.count || 1;

  return (
    <div className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="commercial-funnel-global-widget">
      <h3 className="text-base font-semibold mb-4" style={{ color: "var(--oh-text)" }}>
        Entonnoir de conversion global
      </h3>
      <div className="space-y-2">
        {funnel.map((step, i) => {
          const widthPct = Math.max((step.count / maxCount) * 100, 8);
          return (
            <div key={step.key} className="flex items-center gap-3">
              <span className="text-xs w-28 text-right shrink-0 font-mono" style={{ color: "var(--oh-text-muted)" }}>
                {step.label}
              </span>
              <div className="flex-1 relative h-8">
                <div className="h-full rounded-r flex items-center px-2 transition-all duration-500"
                  style={{ width: `${widthPct}%`, background: FUNNEL_COLORS[i] || "var(--oh-stat-blue-text)", minWidth: "60px" }}>
                  <span className="text-xs font-bold text-white whitespace-nowrap">
                    {step.count} ({step.pct}%)
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
